import React, { useEffect, useRef, useCallback } from "react";
import { useLocation } from "react-router-dom";
import PropTypes from "prop-types";


// //Import Scrollbar
import SimpleBar from "simplebar-react";

// MetisMenu
import MetisMenu from "metismenujs";
import withRouter from "components/Common/withRouter";
import { Link } from "react-router-dom";
import { getLoggedInUser } from "../../helpers/fakebackend_helper"
import * as constants from "../../constants/layout"
import './sidebar.scss'
//i18n
import { withTranslation } from "react-i18next";

const SidebarContent = props => {
  const ref = useRef();
  const user = getLoggedInUser()
  const activateParentDropdown = useCallback((item) => {
    item.classList.add("active");
    const parent = item.parentElement;
    const parent2El = parent.childNodes[1];

    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show");
    }

    if (parent) {
      parent.classList.add("mm-active");
      const parent2 = parent.parentElement;

      if (parent2) {
        parent2.classList.add("mm-show"); // ul tag

        const parent3 = parent2.parentElement; // li tag

        if (parent3) {
          parent3.classList.add("mm-active"); // li
          parent3.childNodes[0].classList.add("mm-active"); //a
          const parent4 = parent3.parentElement; // ul
          if (parent4) {
            parent4.classList.add("mm-show"); // ul
            const parent5 = parent4.parentElement;
            if (parent5) {
              parent5.classList.add("mm-show"); // li
              parent5.childNodes[0].classList.add("mm-active"); // a tag
            }
          }
        }
      }
      scrollElement(item);
      return false;
    }
    scrollElement(item);
    return false;
  }, []);

  const removeActivation = (items) => {
    for (var i = 0; i < items.length; ++i) {
      var item = items[i];
      const parent = items[i].parentElement;

      if (item && item.classList.contains("active")) {
        item.classList.remove("active");
      }
      if (parent) {
        const parent2El =
          parent.childNodes && parent.childNodes.lenght && parent.childNodes[1]
            ? parent.childNodes[1]
            : null;
        if (parent2El && parent2El.id !== "side-menu") {
          parent2El.classList.remove("mm-show");
        }

        parent.classList.remove("mm-active");
        const parent2 = parent.parentElement;

        if (parent2) {
          parent2.classList.remove("mm-show");

          const parent3 = parent2.parentElement;
          if (parent3) {
            parent3.classList.remove("mm-active"); // li
            parent3.childNodes[0].classList.remove("mm-active");

            const parent4 = parent3.parentElement; // ul
            if (parent4) {
              parent4.classList.remove("mm-show"); // ul
              const parent5 = parent4.parentElement;
              if (parent5) {
                parent5.classList.remove("mm-show"); // li
                parent5.childNodes[0].classList.remove("mm-active"); // a tag
              }
            }
          }
        }
      }
    }
  };

  const path = useLocation();
  const activeMenu = useCallback(() => {
    const pathName = path.pathname;
    let matchingMenuItem = null;
    const ul = document.getElementById("side-menu");
    const items = ul.getElementsByTagName("a");
    removeActivation(items);

    for (let i = 0; i < items.length; ++i) {
      if (pathName === items[i].pathname) {
        matchingMenuItem = items[i];
        break;
      }
    }
    if (matchingMenuItem) {
      activateParentDropdown(matchingMenuItem);
    }
  }, [path.pathname, activateParentDropdown]);

  useEffect(() => {
    ref.current.recalculate();
  }, []);

  useEffect(() => {
    new MetisMenu("#side-menu");
    activeMenu();
  }, []);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    activeMenu();
  }, [activeMenu]);

  function scrollElement(item) {
    if (item) {
      const currentPosition = item.offsetTop;
      if (currentPosition > window.innerHeight) {
        ref.current.getScrollElement().scrollTop = currentPosition - 300;
      }
    }
  }

  return (
    <React.Fragment>
      <SimpleBar className="h-100" ref={ref}>
        <div id="sidebar-menu" className="sidebardesign">
          <ul className="metismenu list-unstyled" id="side-menu">
            <li>
          <Link to="/dashboard" className="has-arrow">
                  <i className="dripicons-align-justify"></i>
                  <span><strong>{props.t("Master")}</strong></span>
                </Link>
                <ul className="sub-menu">
                <li>
              <Link to="/unit" >
                <i className="bx bx-ruler"></i>{props.t("Unit")}
              </Link>             
            </li>
            <li>
            <Link to="/itemgroup"><i className="bx bx-sitemap"></i>{props.t("Item Group")}</Link>
              {/* <Link to="/#" >
                <i className="bx bx-sitemap"></i>
                <span>{props.t("Item Group")}</span>
              </Link>              */}
            </li>
            <li>
              <Link to="/item" >
                <i className="bx bx-file"></i>
                {props.t("Item")}
              </Link>             
            </li>
            <li>
              <Link to="/party" >
                <i className="bx bx-user-plus"></i>
                <span>{props.t("Party ")}</span>
              </Link>             
            </li>
            <li>
              <Link to="/price-change" >
                <i className="bx bx-rupee"></i>
                <span>{props.t("Price Change ")}</span>
              </Link>             
            </li>
            <li>
              <Link to="/user" >
                <i className="bx bx-user"></i>{props.t("User Management")}
              </Link>              
            </li>
                </ul>
                </li>
                <li>
                <Link to="/" className="has-arrow">
                  <i className="bx bx-file me-2"></i>
                  <span><strong>{props.t("Reports")}</strong></span>
                </Link>
                <ul className="sub-menu">
            <li>
              <Link to="/price-list" >
                <i className="bx bx-rupee"></i>{props.t("Price List")}
              </Link>
              
            </li>
            <li>
              <Link to="/outward-date-wise-report" >
                <i className="bx bx-log-out-circle"></i>
                <span>{props.t("Outward Date-wise")}</span>
              </Link>
              
            </li>
            <li>
              <Link to="/inward-date-wise-report" >
                <i className="bx bx-log-in-circle"></i>
                <span>{props.t("Inward Date-wise")}</span>
              </Link>
              
            </li>
            <li>
              <Link to="/outward-party-wise-report" >
                <i className="bx bx-log-out-circle"></i>
                <span>{props.t("Outward Party-wise")}</span>
              </Link>
              
            </li>
            <li>
              <Link to="/inward-party-wise-report" >
                <i className="bx bx-log-in-circle"></i>
                <span>{props.t("Inward Party-wise")}</span>
              </Link>
              
            </li>
            </ul>
                </li>
          </ul>
        </div>
      </SimpleBar>
    </React.Fragment>
  );
};

SidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};

export default withRouter(withTranslation()(SidebarContent));
